import { Button, message } from "antd";
import { useEffect, useState } from "react";
import StepCard from "../ui/StepCard";
import { Card, ListItem } from "./SectionTwo.default";
import CompletedStageCard from "../ui/CompletedStageCard";

const awarnessStageStepCards: Card[] = [
  {
    count: 1,
    status: "completed",
    title:
      "Evaluate Objectives, Investigate Incidents, and Conduct goal assessment",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Assess the effectiveness of strategies, address incidents, and
          proactively identify risks through internal audits.
        </li>
        <li>
          Use the Goal Assessment Tool to record areas of success and
          improvement.
        </li>
        <span>Categorize Outcomes:</span>
        <ul>
          <li>Achieved: Fully met or exceeded targets.</li>
          <li>
            Partially Achieved: Made progress but did not fully meet the goal.
          </li>
          <li>Not Achieved: Fell significantly short of the target.</li>
        </ul>
      </>
    ),
    backgroundColor: "#a0a0c2",
    actions: [
      {
        name: "Start",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 2,
    status: "completed",
    title: "Create the well-being policy",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Consolidate findings from Stage 1 and Stage 2 into an updated,
          data-driven well-being policy.
        </li>
        <li>Use the platform’s Policy Builder to include:</li>

        <li>Evaluation results from the Preliminary Progress Report.</li>
        <li>
          Updated objectives based on audit findings and investigation outcomes.
        </li>
        <li>Procedures for incident reporting and risk control.</li>
        <li>
          Present the updated policy to leadership via the platform’s
          Communication Tool.
        </li>
        <li>
          Publish the policy for employees and monitor acknowledgment via the
          Policy Awareness Dashboard.
        </li>
      </>
    ),
    backgroundColor: "#8eb1bd",
    actions: [
      {
        name: "start",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
];

const completedStageList: ListItem[] = [
  {
    name: "Review Your Inputs:",
    items: [
      "Visit the Preliminary Progress Report page to review all progress metrics, program results, and audit findings.",
      "Use the View Summary option to ensure all data is accurate and complete.",
    ],
  },
  {
    name: "Submit the Evaluation & Reporting Stage:",
    items: [
      "Once you’re satisfied with your inputs and findings, click the Submit Stage button.",
      "A confirmation popup will appear. Confirm to lock your inputs and generate the finalized Well-Being Evaluation Report.",
    ],
  },
  {
    name: "Post-Submission Access:",
    items: [
      "After submission, this stage will be locked for edits but will remain accessible for viewing and exporting reports.",
      "If you need to make changes after submission, contact your platform administrator to reopen the stage.",
    ],
  },
  {
    name: "Move to the Next Stage:",
    items: [
      "Upon submission, you’ll be automatically redirected to the Overview page, where you can continue with the Next Year’s Planning or conduct a review of overall processes.",
    ],
  },
  {
    name: "Refer Back to This Stage:",
    items: [
      "You can revisit the Evaluation & Reporting Stage anytime by clicking its tab in the Overview Section.",
    ],
  },
];

const completedStageTitle = "Completing the Evaluation & Reporting Stage";

const subTitleText = (
  <p>
    Congratulations on completing the Evaluation & Reporting stage! Follow these
    steps to finalize this stage:
  </p>
);

function SectionTwo() {
  const [submitActive, setSubmitActive] = useState(false);
  const [showCompletedStage, setShowCompletedStage] = useState(false);

  //Lifecycle
  useEffect(() => {
    findUncompletedSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Events
  function onSubmit() {
    setShowCompletedStage(true);
  }

  // Methods
  function findUncompletedSteps() {
    const uncompletedSteps = awarnessStageStepCards.filter(
      (step) => step.status !== "completed",
    );

    if (uncompletedSteps.length) {
      setSubmitActive(false);
    } else {
      setSubmitActive(true);
    }

    return uncompletedSteps;
  }

  return (
    <section className="mx-auto max-w-[1920px] px-16 py-16">
      {/* Step Cards */}
      {awarnessStageStepCards.map((card) => {
        return (
          <StepCard
            key={card.count}
            countValue={card.count}
            status={card.status}
            title={card.title}
            checkListTitle={card.listTitle}
            checkList={card.checkList}
            backgroundColor={card.backgroundColor}
            actions={card.actions}
          />
        );
      })}
      {/* Submit Button */}
      <div className="flex justify-center py-8">
        <Button
          disabled={!submitActive}
          className={`bg-[#ffc107] px-16 py-8 text-lg font-bold tracking-wide ${submitActive && "hover:text-white"} `}
          onClick={onSubmit}
        >
          SUBMIT
        </Button>
      </div>
      {/* Completed Stage Component That Shows On Submmit */}
      {(showCompletedStage || submitActive) && (
        <CompletedStageCard
          title={completedStageTitle}
          subTitleText={subTitleText}
          list={completedStageList}
        />
      )}
    </section>
  );
}

export default SectionTwo;
